import { Mapper } from '../services/Mapper'

export default {
  map: null,

  methods: {
    zoomIn () {
      this.mapper.zoomIn()
    },

    zoomOut () {
      this.mapper.zoomOut()
    },

    goHome () {
      const home = this.$storage.get('home', Mapper.defaultHome)
      this.mapper.flyTo(home)
    }
  },

  created () {
    this.mapper = Mapper.instance
  }
}
